import cn from 'classnames';

import { Text } from '@sravni/react-design-system/lib/Typography';

import type { CellContext } from '@tanstack/table-core';

import type { RatingItem } from '../../../types/rating';

import styles from './columns.module.scss';

export const makeOrdinalNumberColumn = <T extends RatingItem>(info: CellContext<T, any>) => {
  const { table, row } = info;
  const ordinalNumber = table.getSortedRowModel()?.flatRows?.findIndex((flatRow) => flatRow.id === row.id) || 0;

  return (
    <Text size={12} className={cn(styles.commonColumn, styles.ordinalNumber)}>
      {ordinalNumber + 1}
    </Text>
  );
};
